// import React from 'react'
// import { useRoutes } from 'react-router';
// import Home from '../Pages/Home/Home';
// import NotFoundPage from '../Pages/NotFoundPage/NotFoundPage';
// import OwnLayout from '../layout/OwnLayout';
// import SevicesPage from '../Pages/SevicesPage/SevicesPage';
// import ExperienceGallery from '../Pages/ExperienceGallery/ExperienceGallery';
// import AboutPage from '../Pages/AboutPage/AboutPage';
// import ExperienceGalleryDetail from '../Pages/ExperienceGalleryDetail/ExperienceGalleryDetail';
// const RoutesWrapper = ({t}) => {
//     const routes = useRoutes([
//       {
//         path: '*',
//         element: <NotFoundPage t={t} />,
//       },
//       {
//         path: '/',
//         element:<OwnLayout t={t} />,
//         children: [
//           {
//             index: true,
//             element: <Home t={t} />,
//           },
//           {
//             path: "services",
//             element: <SevicesPage t={t} />,
//           },
//           {
//             path: "experience",
//             element: <ExperienceGallery t={t} />,
//           },
//           {
//             path: "experience/:id",
//             element: <ExperienceGalleryDetail t={t} />,
//           },
//           {
//             path: "about",
//             element: <AboutPage t={t} />,
//           },
//         ],
//       },
//     ]);
//     return routes;
// }

// export default RoutesWrapper

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../Pages/Home/Home';
import NotFoundPage from '../Pages/NotFoundPage/NotFoundPage';
import OwnLayout from '../layout/OwnLayout';
import SevicesPage from '../Pages/SevicesPage/SevicesPage';
import ExperienceGallery from '../Pages/ExperienceGallery/ExperienceGallery';
import AboutPage from '../Pages/AboutPage/AboutPage';
import ExperienceGalleryDetail from '../Pages/ExperienceGalleryDetail/ExperienceGalleryDetail';
const RoutesWrapper = ({ t }) => {
  return (
    <Routes>
      <Route path="*" element={<NotFoundPage t={t} />} />

      {/* Main route*/}
      <Route path="/" element={<OwnLayout t={t} />}>
        <Route index element={<Home t={t} />} />
        <Route path="services" element={<SevicesPage t={t} />} />
        <Route path="projects" element={<ExperienceGallery t={t} />} />
        <Route
          path="projects/:id"
          element={<ExperienceGalleryDetail t={t} />}
        />
        <Route path="about" element={<AboutPage t={t} />} />
      </Route>

      {/* Routes ar language */}
      <Route path="/ar" element={<OwnLayout t={t} />}>
        <Route index element={<Home t={t} />} />
        <Route path="services" element={<SevicesPage t={t} />} />
        <Route path="projects" element={<ExperienceGallery t={t} />} />
        <Route
          path="projects/:id"
          element={<ExperienceGalleryDetail t={t} />}
        />
        <Route path="about" element={<AboutPage t={t} />} />
      </Route>
    </Routes>
  );
};

export default RoutesWrapper;
